var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"ls-scroll",rawName:"v-ls-scroll",value:(_vm.checkScroll),expression:"checkScroll"}],class:{ affix: _vm.affixed },style:({ width: _vm.width })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }